type OperatorIconProps = {
  op: "+" | "-" | "*" | "/" | "^" | "(" | ")";
};

export const OperatorIcon = ({ op }: OperatorIconProps) => (
  <span className="text-[24px] leading-none text-foreground">{opSymbols[op] ?? op}</span>
);

const opSymbols: Record<string, string> = {
  "^": "^",
  "+": "+",
  "-": "−",
  "*": "×",
  "/": "÷",
  "(": "(",
  ")": ")",
};
